<div style="width: 100%;height: 100%;overflow-y: auto;justify-content: center;display: flex;">
          <div style="width: 50%;height: 20%;">
            <ng-container *ngFor="let job of jobOpenings" >
                <div class="card">
                       <div class="jobHeader" style="display: flex;">
                             <div style="width: 70%;height: 100%;" class="border">
                                 <div class="jobTitle ellipsis" title="DATA Cloud">
                                    {{job.domain}}
                                 </div>
                                 <div class="jobEmployer ellipsis" title="DATA Cloud">
                                    {{job.employer}}
                                 </div>
                                 <div class="jobHeaderOthers">
                                       <div style="width: 50%;display: flex;align-items: center;" class="ellipsis">
                                             <mat-icon class="otherIcon"> my_location</mat-icon>  {{job.category}}
                                       </div>
                                       <div style="width: 50%;display: flex;align-items: center;" class="ellipsis">
                                             <mat-icon class="otherIcon"> my_location</mat-icon>  {{job.location}}
                                       </div>
                                 </div>
                             </div>
                             <div style="width: 30%;height: 100%;display: flex;justify-content: end;">
                                <img *ngIf="isMetadataAvailable(job)" [src]="job.linkMetaData?.image" style="width: 60%; height: 100%;" />
                                <img *ngIf="!isMetadataAvailable(job)" src="../assets/link.png" style="width: 60%; height: 100%;" />
                             </div>
                       </div>
                       <div class="jobBody" style="display: flex;">
                             <div class="jobHeaderOthers ellipsis" style="display: flex;align-items: center;">
                                <mat-icon class="otherIcon"> my_location</mat-icon>  {{job.description}}
                             </div>
                             <div>
                                 
                             </div>
                       </div>
                       <div class="jobFooter">

                       </div>
                </div>
            </ng-container>
        </div>
</div>